import crypto from 'crypto';
export function isValidEmail(email) {
    const regexp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regexp.test(email);
}
export class UuidIdGenerator {
    newId = () => crypto.randomUUID();
}
export function* rangeInclusive(start, end, step = 1) {
    if (end === undefined)
        [end, start] = [start, 0];
    for (let n = start; n <= end; n += step)
        yield n;
}
//# sourceMappingURL=index.js.map